he.pages.contact.init = function () {
    // first option isn't selectable
    $(document.getElementById('subject')).find('option').first().attr('disabled', 'disabled')
};